import { useProperties, useFormProps, useConfigStore } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import BaseForm from './BaseForm';
import LanguageToggle from './LanguageToggle';

export default function EmbeddedForm() {
	const { formType, formOpen } = useFormStore();
	const { webView } = useFormProps();
	const { translation = {} } = useProperties();
	const { themeClass } = useConfigStore();

	return (
		<form
			data-mop-form-type={formType}
			className={`mopinion-survey-content wcag ${
				!webView ? 'overflow-visible' : ''
			} ${themeClass}`}
			{...(!formOpen && {
				style: {
					display: 'none'
				}
			})}
		>
			{translation?.useTranslation && translation?.useToggle && <LanguageToggle />}
			<BaseForm />
		</form>
	);
}
